import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LockerCheckoutPage } from './locker-checkout.page';
import { PipesModule } from 'app/pipes/pipes.module';
import { RouterModule } from '@angular/router';



@NgModule({
  imports: [
    CommonModule,
    PipesModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule
  ],
  declarations: [LockerCheckoutPage]
})
export class LockerCheckoutPageModule {}
